import { Box, Stack, Chip, Typography } from '@mui/material';

import { Weekday } from '@occc/graphql';

import { WEEKDAYS } from '../../../touchpoint.constants';

type WeekdaySelectorProps = {
  selectedDays: Weekday[];
  onDayToggle: (day: Weekday) => void;
  label?: string;
  error?: string;
};

export const WeekdaySelector = ({
  selectedDays,
  onDayToggle,
  label = 'Weekdays',
  error,
}: WeekdaySelectorProps) => {
  const borderStyle = {
    borderBottom: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    pb: 3,
    mb: 3,
    mt: 3,
  };

  return (
    <Box sx={borderStyle}>
      <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
        {label}
      </Typography>
      <Stack direction='row' spacing={1} flexWrap='wrap' useFlexGap>
        {WEEKDAYS.map((day) => (
          <Chip
            key={day.value}
            label={day.label}
            onClick={() => onDayToggle(day.value)}
            color={selectedDays?.includes(day.value) ? 'primary' : 'default'}
            variant={selectedDays?.includes(day.value) ? 'filled' : 'outlined'}
            sx={{ cursor: 'pointer' }}
          />
        ))}
      </Stack>

      {error && (
        <Typography variant='caption' color='error' sx={{ mt: 1, display: 'block' }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};
